import React, { useState } from "react";
import { Toaster } from "sonner";
import { TreePine, RefreshCw } from "lucide-react";
import { StaffPinGate } from "../components/StaffPinGate";
import { hasCheckinAuth } from "../lib/checkinApi";
import { InstallHomeButton } from "../components/InstallHomeButton";
import MusicPanel from "../components/admin/music/MusicPanel";

export default function AmbientiPage() {
  const [authed, setAuthed] = useState(hasCheckinAuth());
  if (!authed) return <StaffPinGate title="Ambienti · musica e luci" onUnlock={() => setAuthed(true)} />;
  return (
    <div className="min-h-screen bg-[#eef3ea] text-[#2b1410]" data-testid="ambienti-page">
      <Toaster position="top-center" richColors />
      <header className="sticky top-0 z-30 bg-[#2b7a46] text-[#f3f7ef] px-3 py-2">
        <div className="max-w-6xl mx-auto flex items-center gap-2">
          <div className="h-9 w-9 rounded-xl bg-[#c99b4a] flex items-center justify-center"><TreePine className="h-5 w-5 text-[#2b7a46]" /></div>
          <div className="mr-auto">
            <div className="font-serif text-lg font-bold leading-tight">Ambienti</div>
            <div className="text-[11px] opacity-80">Musica e luci · Ristorante, Spa, Piscina</div>
          </div>
          <InstallHomeButton appName="Ambienti" compact className="text-[#f3f7ef]" />
          <button onClick={() => window.location.reload()} className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center" title="Ricarica" data-testid="ambienti-reload"><RefreshCw className="h-4 w-4" /></button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto p-3 sm:p-4">
        <MusicPanel compact />
      </main>
    </div>
  );
}
